import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'

// Using MongoDB database with abstraction layer

// Global styles
import './assets/css/main.css'

// Database initialization
import { initializeDatabase } from './database'

// Initialize database before creating the app
async function initializeApp(): Promise<void> {
  try {
    // Initialize database service
    await initializeDatabase()
    
    // Create Vue app
    const app = createApp(App)
    
    // Use plugins
    app.use(createPinia())
    app.use(router)
    
    // Mount app
    app.mount('#app')
  } catch (error) {
    console.error('Failed to initialize application:', error)
    
    // In development mode with auth skip, continue anyway
    if (import.meta.env.VITE_SKIP_AUTH === 'true') {
      console.warn('🚀 DEVELOPMENT MODE: Database initialization failed, but continuing anyway...')
      
      // Create Vue app even with database error
      const app = createApp(App)
      
      // Use plugins
      app.use(createPinia())
      app.use(router)
      
      // Mount app with warning banner
      app.mount('#app')
      
      // Note: Warning notification will be shown via useToast composable if needed
      
      return
    }
    
    // Show error to user
    const errorMessage = error instanceof Error ? error.message : 'Unknown error'
    document.body.innerHTML = `
      <div style="display: flex; justify-content: center; align-items: center; height: 100vh; flex-direction: column; font-family: Arial, sans-serif;">
        <h1 style="color: red;">Application Initialization Failed</h1>
        <p>Please check your database configuration and try again.</p>
        <p style="color: #666; font-size: 0.9em;">${errorMessage}</p>
        <button onclick="window.location.reload()" style="margin-top: 20px; padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">Retry</button>
      </div>
    `
  }
}

// Initialize the application
initializeApp()

